const getKPI = (transactions) => {
  const income = transactions
    .filter((transaction) => transaction.type === "income")
    .map((transaction) => transaction.amount)
    .reduce((acc, amount) => acc + amount, 0);
  const expense = transactions
    .filter((transaction) => transaction.type === "expense")
    .map((transaction) => transaction.amount)
    .reduce((acc, amount) => acc + amount, 0);
  const balance = income - expense;

  const setNeedleValue = (balance, income) => {
    if (balance <= 0) {
      return 0;
    } else if (balance > 0 && balance < income) {
      return (balance / income) * 150;
    } else if (balance === income) {
      return 150;
    }
  };

  const needleValue = setNeedleValue(balance, income);

  return {
    income,
    expense,
    balance,
    needleValue,
  };
};

export default getKPI;
